import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { FieldGroup, FormCard, SubmitButton } from '../../reusable'

import { FormPartInterface } from '../../../interfaces'
import { useClaimData } from '../../../claimProvider'
import { api } from '../../../services'
import Notiflix from 'notiflix'
import axios from 'axios'

const OPEN_BANKING_BASE_URL = 'https://web.boshhh-report.com/'

/**
 * Open Banking URL Payload
 * 
    "merchant-identifier": "string",
    "first_name": "string",
    "last_name": "string", 
    "mobile": "+441234567890",
    "email": "user@example.com",
    "agreement_date": "2024-08-01",
    "date_of_birth": "1990-01-01",
    "address_street": "123 Example Street",
    "address_building_number": "12 A",
    "address_postcode": "SW1A 1AA",
    "redirect_url": "https%3A%2F%2Fexample.com%2Fwelcome%3Fparameter%3Dexample",
    "external_ref": "external_ref",
    "template_id": "template-id",
    "title": "Mr",
    "middle_name": "John",
    "fintech_client_id": "string" 
 */

export const OpenBankingStep = (props: FormPartInterface) => {
    const { isActive } = props
    const claim = useClaimData()

    const [currentStep, setCurrentStep] = useState(0)
    const [openBankingUrl, setOpenBankingUrl] = useState('')
    const [postCurrentStep, setPostCurrentStep] = useState(0)

    const REQUIRED_FIELDS = [
        'title',
        'firstname',
        'lastname',
        'phone',
        'email',
        'dob',
        'house_number',
        'street',
        'postcode',
    ]

    useEffect(() => {
        if (isActive == 'openBanking') {
            console.log('OB CLAIM: ', claim)

            if (claim && claim.openBankingLink) {
                console.log('HAS OPEN BANKING URL: ', claim.openBankingLink)
                setOpenBankingUrl(claim.openBankingLink)
            }
        }
    }, [claim, isActive])

    const startOpenBanking = async () => {
        try {
            console.log('RECORDING CLICK')
            Notiflix.Loading.standard('Connecting to Boshhh')
            const response = await axios({
                method: 'post',
                url: `${process.env.REACT_APP_API}/record-click`,
                data: { clickData: { ...claim, introducer: 'MBFCheck' }, clickType: 'open_banking_click' },
            })
            console.log('RESPONSE: ', response)
            Notiflix.Loading.remove()
        } catch (error: any) {
            console.log('ERROR: ', error)
            console.log('ERROR MESSAGE: ', error.message)
            Notiflix.Loading.remove()
        }

        window.location.href = openBankingUrl
    }

    const getCurrentStep = () => {
        return isActive == 'openBanking' ? (
            <FieldGroup title="Open Banking">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                    <div style={{ marginBottom: '50px', textAlign: 'center' }}>
                        {/* <h2 style={{ textAlign: 'center' }}>Thank you!</h2> */}
                        <p className={styles.tagline} style={{ marginTop: '0px', textAlign: 'center' }}>
                            We're assessing your agreement and will contact you shortly to confirm the number of claims
                            we've identified.
                        </p>
                        <p
                            style={{
                                textAlign: 'center',
                                lineHeight: '1.8',
                                marginTop: '0',
                                marginBottom: '50px',
                                letterSpacing: '1px',
                                fontSize: '15px',
                                color: 'grey',
                            }}
                        >
                            For the most accurate results and to speed up your compensation process, please complete our
                            secure open-banking check. <br />
                            This evidence helps us verify your payment history and could uncover further compensation
                            due to your PCP provider lending irresponsibly.
                        </p>
                        <SubmitButton
                            onClick={() => startOpenBanking()}
                            text="Proceed to the secure payment review →"
                            btnType="primary"
                        />

                        <div className={styles.infoSection}>
                            <div className={styles.infoColumns}>
                                <div className={styles.infoColumn}>
                                    <p className={styles.infoTitle}>Why we need this:</p>
                                    <ul className={styles.infoList}>
                                        <li>Confirms your PCP history</li>
                                        <li>Identifies hidden refunds</li>
                                        <li>Maximises your compensation</li>
                                    </ul>
                                </div>
                                <div className={styles.infoColumn}>
                                    <p className={styles.infoTitle}>Your security:</p>
                                    <ul className={styles.infoList}>
                                        <li>Bank-level encryption</li>
                                        <li>No login details shared</li>
                                        <li>You stay in control</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className={styles.disclaimer}>
                            <span className={styles.disclaimerText}>
                                Skipping this step may mean missing out on thousands owed to you.
                            </span>
                        </div>
                    </div>
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
